export default __webpack_public_path__ + "static/media/photo--lg--reception.9336af02.jpg";